import React, { useState } from 'react';
import { CustomizedTypography } from '@components/Customized';
import { Tab, Tabs } from '@material-ui/core';
import { useStyles } from './styles';
import { URL_PARAM, URL_PARAM_TYPE } from '@routes/Contacts/types';
import {
  myContactsPathName,
  myContactsRecommendedPathName
} from '@routes/Common/types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

interface Props {
  urlParam?: string;
}

const TabPanelControl = (props: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { urlParam } = props;
  const [value, setValue] = useState(
    urlParam
      ? urlParam === URL_PARAM.myContactsType
        ? URL_PARAM_TYPE.myContactsType
        : urlParam === URL_PARAM.recommendedType
        ? URL_PARAM_TYPE.recommendedType
        : URL_PARAM_TYPE.myContactsType
      : URL_PARAM_TYPE.myContactsType
  );

  const history = useHistory();
  return (
    <>
      <div className={classes.container}>
        <Tabs
          className={classes.tabs}
          value={value}
          variant="fullWidth"
          onChange={(event, value) => {
            if (value === URL_PARAM_TYPE.myContactsType) {
              history.push(myContactsPathName);
            } else if (value === URL_PARAM_TYPE.recommendedType) {
              history.push(myContactsRecommendedPathName);
            }
            setValue(value);
          }}
        >
          <Tab
            label={
              <CustomizedTypography
                variant="body2"
                className={clsx(
                  classes.title,
                  value === URL_PARAM_TYPE.myContactsType ? classes.active : ''
                )}
              >
                {t('contact.my_contacts.title')}
              </CustomizedTypography>
            }
          />
          <Tab
            label={
              <CustomizedTypography
                variant="body2"
                className={clsx(
                  classes.title,
                  value === URL_PARAM_TYPE.recommendedType ? classes.active : ''
                )}
              >
                {t('contact.recommended_contacts.recommended')}
              </CustomizedTypography>
            }
          />
        </Tabs>
      </div>
    </>
  );
};

export default TabPanelControl;
